(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wmi-hat-steps"] && !Shopify.designMode) return;
  try {
    // Adds lines to the cart and opens the cart drawer through Shopify's cart actions, which
  // Horizon listens to. Falls back to the AJAX cart and the cart page.
  if (!window.wmiAddToCart) {
    window.wmiAddToCart = async (lines) => {
      const actions = window.Shopify && window.Shopify.actions;
      if (actions && actions.updateCart) {
        const result = await actions.updateCart({
          lines: lines.map((line) => ({
            merchandiseId: String(line.id),
            quantity: line.quantity || 1,
            attributes: Object.entries(line.properties || {}).map(([key, value]) => ({ key, value: String(value) })),
          })),
        });
        if (result && result.userErrors && result.userErrors.length) throw new Error(result.userErrors[0].message);
        if (actions.openCart) await actions.openCart();
        return result;
      }
      const response = await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines.map((l) => ({ id: Number(l.id), quantity: l.quantity || 1, properties: l.properties || {} })) }),
      });
      if (!response.ok) throw new Error('Could not add to cart');
      window.location.href = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart`;
      return response.json();
    };
  }

  if (!customElements.get('wmi-hat-builder')) {
    class WmiHatBuilder extends HTMLElement {
      connectedCallback() {
        try {
          this.products = JSON.parse(this.querySelector('[data-products]').textContent);
        } catch (e) {
          return;
        }
        this.mode = this.dataset.designMode;
        const firstSize = this.querySelector('[data-size][aria-checked="true"]');
        this.state = { size: firstSize ? firstSize.dataset.size : 'adult', colour: null, design: null };
        const firstColour = this.querySelector('[data-colour][aria-checked="true"]');
        const firstDesign = this.querySelector('[data-design][aria-checked="true"]');
        this.state.colour = firstColour ? firstColour.dataset.colour : null;
        this.state.design = firstDesign ? firstDesign.dataset.design : null;

        this.bindGroup('[data-colour]', (el) => {
          this.state.colour = el.dataset.colour;
          this.offerJump();
        });
        this.bindGroup('[data-design]', (el) => {
          this.state.design = el.dataset.design;
          this.offerJump();
        });
        this.bindGroup('[data-size]', (el) => {
          this.state.size = el.dataset.size;
          this.syncColours();
          this.syncDesigns();
          this.packDesigns();
        });
        this.bindGroup('[data-band]', (el) => (this.state.band = el));
        this.state.band = this.querySelector('[data-band][aria-checked="true"]');
        this.syncColours();
        this.syncDesigns();
        this.packDesigns();
        if (document.fonts) document.fonts.ready.then(() => this.packDesigns());
        const designList = this.querySelector('.wmi-builder__designs');
        if (designList && 'ResizeObserver' in window) {
          new ResizeObserver(() => {
            if (designList.clientWidth && designList.clientWidth !== this.packedWidth) this.packDesigns();
          }).observe(designList);
        }
        this.setupViz();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.disableUnbuyableSizes();
        this.update();
      }

      bindGroup(selector, set) {
        const buttons = Array.from(this.querySelectorAll(selector));
        buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            buttons.forEach((b) => b.setAttribute('aria-checked', String(b === button)));
            set(button);
            this.update();
          });
          button.addEventListener('keydown', (event) => {
            if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
            event.preventDefault();
            const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
            const visible = buttons.filter((b) => !b.hidden);
            const at = visible.indexOf(button);
            const next = visible[(at + step + visible.length) % visible.length];
            next.focus();
            next.click();
          });
        });
      }

      syncDesigns() {
        // Kids and adult hats can have their own designs. Show the set for the chosen size,
        // and move the selection to that set if the current design isn't in it.
        const buttons = Array.from(this.querySelectorAll('[data-design]'));
        if (!buttons.some((b) => b.dataset.audience === 'kids')) return;
        const want = this.state.size === 'kids' ? 'kids' : 'adult';
        // Remember each set's pick, so switching size and back keeps the design they chose
        this.lastDesign = this.lastDesign || {};
        const previous = buttons.find((b) => !b.hidden && b.getAttribute('aria-checked') === 'true');
        if (previous) this.lastDesign[previous.dataset.audience || 'adult'] = previous;
        buttons.forEach((b) => (b.hidden = (b.dataset.audience || 'adult') !== want));
        let current = buttons.find((b) => !b.hidden && b.getAttribute('aria-checked') === 'true');
        if (!current) {
          const remembered = this.lastDesign[want];
          current = (remembered && !remembered.hidden ? remembered : buttons.find((b) => !b.hidden)) || null;
          buttons.forEach((b) => b.setAttribute('aria-checked', String(b === current)));
          this.state.design = current ? current.dataset.design : null;
        }
      }

      packDesigns() {
        // On phones, order the design pills so the list takes as few lines as possible:
        // longest first, each into the first line with room (first-fit decreasing). Lines then
        // run in the shop's own order, by each line's earliest design.
        const list = this.querySelector('.wmi-builder__designs');
        if (!list) return;
        this.designOrder = this.designOrder || Array.from(list.querySelectorAll('[data-design]'));
        if (!window.matchMedia('(max-width: 749px)').matches) {
          this.packedWidth = 0;
          this.designOrder.forEach((button) => list.append(button));
          return;
        }
        const width = list.clientWidth;
        if (!width) return;
        this.packedWidth = width;
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        const visible = this.designOrder.filter((button) => !button.hidden);
        list.classList.add('is-measuring');
        const sizes = new Map(visible.map((button) => [button, Math.ceil(button.getBoundingClientRect().width)]));
        list.classList.remove('is-measuring');
        const rank = new Map(this.designOrder.map((button, index) => [button, index]));
        const lines = [];
        [...visible]
          .sort((a, b) => sizes.get(b) - sizes.get(a))
          .forEach((button) => {
            const size = sizes.get(button);
            const line = lines.find((l) => l.room >= size + gap);
            if (line) {
              line.items.push(button);
              line.room -= size + gap;
            } else {
              lines.push({ items: [button], room: width - size });
            }
          });
        lines.forEach((line) => line.items.sort((a, b) => rank.get(a) - rank.get(b)));
        lines.sort((a, b) => rank.get(a.items[0]) - rank.get(b.items[0]));
        lines
          .flatMap((line) => line.items)
          .concat(this.designOrder.filter((button) => button.hidden))
          .forEach((button) => list.append(button));
      }

      kidsColour(colour) {
        // The kids hat names its colours its own way (Pink for Dusty Pink): match the
        // name exactly, then by a whole word
        const kids = this.products.kids;
        const index = this.optionIndex(kids, this.dataset.colourName);
        if (index === -1 || !colour) return colour;
        const names = Object.keys(kids.valueIds[kids.options[index]] || {});
        const lower = colour.toLowerCase();
        const words = (text) => text.toLowerCase().split(/\s+/);
        return (
          names.find((n) => n.toLowerCase() === lower) ||
          names.find((n) => words(colour).includes(n.toLowerCase()) || words(n).includes(lower)) ||
          null
        );
      }

      colourFor(product) {
        return product && product === this.products.kids ? this.kidsColour(this.state.colour) : this.state.colour;
      }

      syncColours() {
        // Kids hats come in fewer colours. Show only those while Kids is picked, and move the
        // selection to one of them if the current colour isn't made in kids.
        const buttons = Array.from(this.querySelectorAll('[data-colour]'));
        const kidsOnly = this.state.size === 'kids' && this.optionIndex(this.products.kids, this.dataset.colourName) > -1;
        this.lastColour = this.lastColour || {};
        const previous = buttons.find((b) => !b.hidden && b.getAttribute('aria-checked') === 'true');
        if (previous && this.colourSet) this.lastColour[this.colourSet] = previous;
        this.colourSet = kidsOnly ? 'kids' : 'adult';
        buttons.forEach((b) => (b.hidden = kidsOnly && !this.kidsColour(b.dataset.colour)));
        let current = buttons.find((b) => !b.hidden && b.getAttribute('aria-checked') === 'true');
        if (!current) {
          const remembered = this.lastColour[this.colourSet];
          current = (remembered && !remembered.hidden ? remembered : buttons.find((b) => !b.hidden)) || null;
          buttons.forEach((b) => b.setAttribute('aria-checked', String(b === current)));
          this.state.colour = current ? current.dataset.colour : null;
        }
      }

      offerJump() {
        // On phones the preview sits above the options: once they change something, offer a
        // quick way back up to see it
        if (!this.jump || this.vizInView || !window.matchMedia('(max-width: 899px)').matches) return;
        this.showJump(true);
      }

      showJump(show) {
        if (!this.jump) return;
        this.jump.classList.toggle('is-visible', show);
        this.jump.setAttribute('aria-hidden', String(!show));
        this.jump.tabIndex = show ? 0 : -1;
      }

      optionIndex(product, name) {
        if (!product) return -1;
        const wanted = [name, name === 'color' ? 'colour' : name === 'colour' ? 'color' : name];
        return product.options.findIndex((o) => wanted.includes(o.toLowerCase()));
      }

      findVariant(product) {
        if (!product) return null;
        const colourIndex = this.optionIndex(product, this.dataset.colourName);
        const designIndex = this.mode === 'variant' ? this.optionIndex(product, this.dataset.designName) : -1;
        return (
          product.variants.find((v) => {
            if (colourIndex > -1 && v.options[colourIndex] !== this.colourFor(product)) return false;
            if (designIndex > -1 && v.options[designIndex] !== this.state.design) return false;
            return true;
          }) || null
        );
      }

      disableUnbuyableSizes() {
        const kidsButton = this.querySelector('[data-size="kids"]');
        if (kidsButton && this.state.size !== 'kids' && !(this.products.kids && this.products.kids.available)) {
          kidsButton.disabled = true;
        }
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '$' + '{' + '{amount}' + '}';
        const whole = cents % 100 === 0;
        const amount = (cents / 100).toFixed(whole ? 0 : 2);
        const withSeparators = (value, thousands, decimal) => {
          const [int, dec] = value.split('.');
          return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (dec ? decimal + dec : '');
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
          if (key === 'amount_no_decimals') return withSeparators(Math.round(cents / 100).toString(), ',', '.');
          if (key === 'amount_with_comma_separator') return withSeparators(amount, '.', ',');
          if (key === 'amount_no_decimals_with_comma_separator') return withSeparators(Math.round(cents / 100).toString(), '.', ',');
          return withSeparators(amount, ',', '.');
        });
      }

      remoteKey(product) {
        return `${product.id}|${this.state.colour}|${this.state.design}`;
      }

      async fetchVariant(product) {
        // Liquid only exposes a product's first 250 variants. For the rest, ask Shopify for the
        // exact combination through the product.wmi-variant template.
        const ids = product.options.map((name) => {
          const lower = name.toLowerCase();
          let value = null;
          if (lower === this.dataset.colourName || ['color', 'colour'].includes(lower)) value = this.colourFor(product);
          else if (this.mode === 'variant' && lower === this.dataset.designName) value = this.state.design;
          return value && product.valueIds[name] ? product.valueIds[name][value] : null;
        });
        if (ids.some((id) => !id)) return null;
        this.remote = this.remote || {};
        const key = this.remoteKey(product);
        if (!(key in this.remote)) {
          this.remote[key] = fetch(`${product.url}?view=wmi-variant&option_values=${ids.join(',')}`)
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null);
        }
        const variant = await this.remote[key];
        if (!variant || !variant.id) return null;
        const matches = product.options.every((name, i) => {
          const lower = name.toLowerCase();
          if (lower === this.dataset.colourName || ['color', 'colour'].includes(lower)) return variant.options[i] === this.colourFor(product);
          if (this.mode === 'variant' && lower === this.dataset.designName) return variant.options[i] === this.state.design;
          return true;
        });
        return matches ? variant : null;
      }

      async update() {
        const product = this.products[this.state.size];
        const colourLabel = this.querySelector('[data-selected="colour"]');
        const designLabel = this.querySelector('[data-selected="design"]');
        if (colourLabel) colourLabel.textContent = this.state.colour || '';
        if (designLabel) designLabel.textContent = this.state.design || '';
        const sizeButton = this.querySelector(`[data-size="${this.state.size}"] b`);
        this.querySelector('[data-summary]').textContent = [this.state.colour, this.state.design, sizeButton && sizeButton.textContent]
          .filter(Boolean)
          .join(' · ');
        const bandLabel = this.querySelector('[data-selected="band"]');
        if (bandLabel && this.state.band) bandLabel.textContent = this.state.band.dataset.bandLabel || '';
        this.renderViz();
        const add = this.querySelector('[data-add]');
        const price = this.querySelector('[data-price]');

        let variant = this.findVariant(product);
        if (!variant && product && product.variantsCount > product.variants.length) {
          const ticket = (this.ticket = (this.ticket || 0) + 1);
          add.disabled = true;
          add.textContent = this.dataset.checkingLabel || '…';
          variant = await this.fetchVariant(product);
          if (ticket !== this.ticket) return;
        }

        this.variant = variant;
        if (variant) {
          this.querySelector('[data-variant-input]').value = variant.id;
          const bandPrice = this.state.band && this.state.band.dataset.bandVariant ? Number(this.state.band.dataset.bandPrice || 0) : 0;
          price.textContent = this.formatMoney(variant.price + bandPrice);
        }
        const buyable = Boolean(variant && variant.available);
        add.disabled = !buyable;
        add.textContent = buyable ? this.dataset.addLabel : this.dataset.unavailable;
      }

      onSubmit(event) {
        event.preventDefault();
        if (!this.variant || !this.variant.available) return;
        const product = this.products[this.state.size];
        const properties = {};
        if (this.optionIndex(product, this.dataset.colourName) === -1 && this.state.colour) {
          properties[this.dataset.colourProperty] = this.state.colour;
        }
        if (this.mode !== 'variant' || this.optionIndex(product, this.dataset.designName) === -1) {
          if (this.state.design) properties[this.dataset.designProperty] = this.state.design;
        }
        const band = this.state.band;
        if (band && band.dataset.band) properties[this.dataset.bandProperty] = band.dataset.band;
        const lines = [{ id: this.variant.id, properties }];
        if (band && band.dataset.bandVariant) {
          lines.push({
            id: band.dataset.bandVariant,
            properties: { 'For hat': this.querySelector('[data-summary]').textContent },
          });
        }
        const add = this.querySelector('[data-add]');
        const error = this.querySelector('[data-error]');
        add.disabled = true;
        if (error) error.hidden = true;
        window
          .wmiAddToCart(lines)
          .catch(() => {
            if (error) {
              error.hidden = false;
              error.textContent = this.dataset.errorLabel || this.dataset.unavailable;
            }
          })
          .finally(() => {
            add.disabled = !(this.variant && this.variant.available);
          });
      }

      setupViz() {
        const section = this.closest('[data-wmi-hat-root]');
        this.viz = section ? section.querySelector('[data-viz]') : null;
        if (!this.viz) return;
        try {
          this.vizData = JSON.parse(this.viz.querySelector('[data-viz-data]').textContent);
        } catch (e) {
          this.viz = null;
          return;
        }
        this.vizCanvas = this.viz.querySelector('[data-viz-canvas]');
        this.vizImages = new Map();
        this.vizMasks = new Map();
        this.vizBoxes = new Map();

        this.jump = this.querySelector('[data-viz-jump]');
        if (!this.jump) return;
        this.vizInView = true;
        this.jump.addEventListener('click', () => {
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          (this.vizCanvas || this.viz).scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
          this.showJump(false);
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            ([entry]) => {
              this.vizInView = entry.isIntersecting;
              if (this.vizInView) this.showJump(false);
            },
            { threshold: 0.5 }
          ).observe(this.vizCanvas || this.viz);
        } else {
          this.vizInView = false;
        }
      }

      loadImage(url) {
        if (!this.vizImages.has(url)) {
          this.vizImages.set(
            url,
            new Promise((resolve) => {
              const img = new Image();
              img.crossOrigin = 'anonymous';
              img.decoding = 'async';
              img.onload = () => resolve(img);
              img.onerror = () => resolve(null);
              img.src = url;
            })
          );
        }
        return this.vizImages.get(url);
      }

      // Bounding box of everything that isn't plain background in a picture (white, or transparent).
      contentBox(img, key, test) {
        if (this.vizBoxes.has(key)) return this.vizBoxes.get(key);
        const scan = 200;
        const ratio = Math.min(scan / img.naturalWidth, scan / img.naturalHeight);
        const w = Math.max(1, Math.round(img.naturalWidth * ratio));
        const h = Math.max(1, Math.round(img.naturalHeight * ratio));
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, w, h);
        const data = ctx.getImageData(0, 0, w, h).data;
        let x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (let y = 0; y < h; y++) {
          for (let x = 0; x < w; x++) {
            const i = (y * w + x) * 4;
            if (test(data[i], data[i + 1], data[i + 2], data[i + 3])) {
              if (x < x0) x0 = x;
              if (x > x1) x1 = x;
              if (y < y0) y0 = y;
              if (y > y1) y1 = y;
            }
          }
        }
        const box = x1 < 0 ? { x: 0, y: 0, w: 1, h: 1 } : { x: x0 / w, y: y0 / h, w: (x1 - x0 + 1) / w, h: (y1 - y0 + 1) / h };
        this.vizBoxes.set(key, box);
        return box;
      }

      // Turns design artwork (black lines on white, or on transparent) into a burn layer:
      // the darker and more opaque a pixel, the deeper the burn.
      burnLayer(img, url) {
        if (this.vizMasks.has(url)) return this.vizMasks.get(url);
        const max = 1000;
        const ratio = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
        const w = Math.round(img.naturalWidth * ratio);
        const h = Math.round(img.naturalHeight * ratio);
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, w, h);
        const image = ctx.getImageData(0, 0, w, h);
        const d = image.data;
        const burn = this.vizData.burn.replace('#', '');
        const r = parseInt(burn.slice(0, 2), 16), g = parseInt(burn.slice(2, 4), 16), b = parseInt(burn.slice(4, 6), 16);
        let transparent = false;
        for (let i = 3; i < d.length; i += 4) {
          if (d[i] < 250) {
            transparent = true;
            break;
          }
        }
        for (let i = 0; i < d.length; i += 4) {
          const lum = (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]) / 255;
          const mask = (d[i + 3] / 255) * (1 - lum);
          d[i] = r;
          d[i + 1] = g;
          d[i + 2] = b;
          d[i + 3] = Math.round(Math.min(1, mask * this.vizData.strength) * 255);
        }
        ctx.putImageData(image, 0, 0);
        // Ring artwork with a transparent surround already fills its canvas edge to edge.
        // Artwork on an opaque white square is trimmed to the drawing itself.
        const box = transparent
          ? { x: 0, y: 0, w: 1, h: 1 }
          : this.contentBox(img, `art:${url}`, (rr, gg, bb, aa) => aa > 20 && rr + gg + bb < 700);
        const layer = { canvas, box };
        this.vizMasks.set(url, layer);
        return layer;
      }

      async renderViz() {
        if (!this.viz) return;
        const colour = this.state.colour;
        const design = this.state.design;
        const plainUrl = this.vizData.colours[colour];
        const artUrl = this.vizData.designs[design];
        const caption = this.viz.querySelector('[data-viz-caption]');
        const pending = this.viz.querySelector('[data-viz-pending]');
        const loading = this.viz.querySelector('[data-viz-loading]');
        if (caption) caption.textContent = [colour, design].filter(Boolean).join(' · ');
        const ticket = (this.vizTicket = (this.vizTicket || 0) + 1);
        const canvas = this.vizCanvas;
        const ctx = canvas.getContext('2d');

        if (!plainUrl) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          pending.hidden = false;
          pending.textContent = (this.vizData.pendingColour || '').replace('[colour]', colour || '');
          return;
        }
        loading.hidden = false;
        const [hat, art] = await Promise.all([this.loadImage(plainUrl), artUrl ? this.loadImage(artUrl) : null]);
        if (ticket !== this.vizTicket) return;
        loading.hidden = true;
        if (!hat) {
          pending.hidden = false;
          pending.textContent = (this.vizData.pendingColour || '').replace('[colour]', colour || '');
          return;
        }
        const size = canvas.width;
        ctx.globalCompositeOperation = 'source-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, size, size);
        const fit = Math.min(size / hat.naturalWidth, size / hat.naturalHeight);
        const hw = hat.naturalWidth * fit;
        const hh = hat.naturalHeight * fit;
        const hx = (size - hw) / 2;
        const hy = (size - hh) / 2;
        ctx.drawImage(hat, hx, hy, hw, hh);

        if (art) {
          let layer = null;
          try {
            layer = this.burnLayer(art, artUrl);
          } catch (e) {
            layer = null;
          }
          if (layer) {
            const hatBox = this.contentBox(hat, `hat:${plainUrl}`, (r, g, b, a) => a > 20 && (r + g + b) / 3 < 236);
            const src = layer.box;
            ctx.globalCompositeOperation = 'multiply';
            ctx.drawImage(
              layer.canvas,
              src.x * layer.canvas.width,
              src.y * layer.canvas.height,
              src.w * layer.canvas.width,
              src.h * layer.canvas.height,
              hx + hatBox.x * hw,
              hy + hatBox.y * hh,
              hatBox.w * hw,
              hatBox.h * hh
            );
            ctx.globalCompositeOperation = 'source-over';
          }
          pending.hidden = true;
        } else {
          pending.hidden = false;
          pending.textContent = (this.vizData.pendingDesign || '').replace('[design]', design || '');
        }
      }
    }
    customElements.define('wmi-hat-builder', WmiHatBuilder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wmi-photo-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wmi-gallery')) {
    class WmiGallery extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-dialog]');
        this.stage = this.querySelector('[data-stage]');
        this.img = this.querySelector('[data-main]');
        this.items = [...this.querySelectorAll('[data-go]')];
        if (!this.dialog || !this.items.length) return;
        this.index = 0;

        this.querySelectorAll('[data-open]').forEach((thumb) =>
          thumb.addEventListener('click', () => this.open(Number(thumb.dataset.open)))
        );
        this.items.forEach((item) => item.addEventListener('click', () => this.show(Number(item.dataset.go))));
        this.querySelectorAll('[data-step]').forEach((button) =>
          button.addEventListener('click', () => this.show(this.index + Number(button.dataset.step)))
        );
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => this.setZoom(false));
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') this.show(this.index + 1);
          if (event.key === 'ArrowLeft') this.show(this.index - 1);
        });

        this.img.addEventListener('click', (event) => {
          if (this.dragged) return;
          this.setZoom(!this.stage.classList.contains('is-zoomed'), event);
        });
        this.stage.addEventListener('pointermove', (event) => {
          if (this.stage.classList.contains('is-zoomed')) this.pan(event);
        });

        // Swipe between photos when not zoomed
        let startX = null;
        this.stage.addEventListener('pointerdown', (event) => {
          startX = event.clientX;
          this.dragged = false;
        });
        this.stage.addEventListener('pointerup', (event) => {
          if (startX === null) return;
          const dx = event.clientX - startX;
          startX = null;
          if (this.stage.classList.contains('is-zoomed') || Math.abs(dx) < 50) return;
          this.dragged = true;
          this.show(this.index + (dx < 0 ? 1 : -1));
          setTimeout(() => (this.dragged = false), 50);
        });
      }

      open(index) {
        this.dialog.showModal();
        this.show(index);
      }

      show(index) {
        const count = this.items.length;
        this.index = (index + count) % count;
        const item = this.items[this.index];
        this.setZoom(false);
        this.img.src = item.dataset.src;
        this.img.alt = item.dataset.alt || '';
        this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${count}`;
        this.items.forEach((el) => el.setAttribute('aria-current', el === item ? 'true' : 'false'));
        item.scrollIntoView({ block: 'nearest', inline: 'center' });
        [1, -1].forEach((step) => {
          const next = this.items[(this.index + step + count) % count];
          new Image().src = next.dataset.src;
        });
      }

      setZoom(on, event) {
        this.stage.classList.toggle('is-zoomed', on);
        if (on && event) this.pan(event);
        if (!on) this.img.style.transformOrigin = '';
      }

      pan(event) {
        const rect = this.stage.getBoundingClientRect();
        const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
        const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));
        this.img.style.transformOrigin = `${x}% ${y}%`;
      }
    }
    customElements.define('wmi-gallery', WmiGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wmi-product-card"] && !Shopify.designMode) return;
  try {
    if (!window.wmiAddToCart) {
    window.wmiAddToCart = async (lines) => {
      const actions = window.Shopify && window.Shopify.actions;
      if (actions && actions.updateCart) {
        const result = await actions.updateCart({
          lines: lines.map((line) => ({
            merchandiseId: String(line.id),
            quantity: line.quantity || 1,
            attributes: Object.entries(line.properties || {}).map(([key, value]) => ({ key, value: String(value) })),
          })),
        });
        if (result && result.userErrors && result.userErrors.length) throw new Error(result.userErrors[0].message);
        if (actions.openCart) await actions.openCart();
        return result;
      }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines.map((l) => ({ id: Number(l.id), quantity: l.quantity || 1, properties: l.properties || {} })) }),
      });
      if (!response.ok) throw new Error('Could not add to cart');
      window.location.href = `${root}cart`;
      return response.json();
    };
  }

  if (!customElements.get('wmi-card-buy')) {
    class WmiCardBuy extends HTMLElement {
      connectedCallback() {
        const add = this.querySelector('[data-add]');
        if (!add) return;
        const select = this.querySelector('[data-variant-select]');
        if (select) {
          select.addEventListener('change', () => {
            add.dataset.variantId = select.value;
          });
        }
        add.addEventListener('click', async () => {
          const label = add.textContent;
          const error = this.querySelector('[data-error]');
          add.disabled = true;
          if (error) error.hidden = true;
          try {
            await window.wmiAddToCart([{ id: add.dataset.variantId, quantity: 1 }]);
            add.textContent = this.dataset.addedLabel || label;
            setTimeout(() => (add.textContent = label), 1800);
          } catch (e) {
            if (error) {
              error.hidden = false;
              error.textContent = e.message || 'Sorry, that could not be added.';
            }
          } finally {
            add.disabled = false;
          }
        });
      }
    }
    customElements.define('wmi-card-buy', WmiCardBuy);
  }
  } catch(e) { console.error(e); }
})();

})();
